import { Fragment } from 'react';
import NsContent from 'components/common/ns-content/NsContent';

import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsList } from 'components/common/ns-list/NsList';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { actionUrl } from 'config/static-content';
import { HELP_CONTACT_NUMBER } from 'config/app-config';

export const testId = 'exceptionsTestId';

export const Exceptions = () => {
  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Please give us a call or chat online" />
        <p>We’ll need to talk to you about your move, please speak to us:</p>

        <NsList>
          {[
            <Fragment key={0}>
              <NsAnchor href={actionUrl.contact}>Live chat</NsAnchor>, Monday to
              Friday, 8am-8pm and Saturday 9am-5pm.
            </Fragment>,
            <Fragment key={1}>
              Call us on{' '}
              <NsAnchor
                href={`tel:${HELP_CONTACT_NUMBER.MOVE_IN}`}
                alt={`Call ${HELP_CONTACT_NUMBER.MOVE_IN_LABEL}`}
              >
                {HELP_CONTACT_NUMBER.MOVE_IN_LABEL}
              </NsAnchor>
              , Monday to Friday, 8am-6pm.
            </Fragment>
          ]}
        </NsList>
      </NsContent>
    </NsPanel>
  );
};

export default Exceptions;
